module.exports = __webpack_public_path__ + "img/spacer.f4a3dc05.png";